import { Center, forwardRef } from '@chakra-ui/react';

type DropOverlayProps = {
  isDragActive?: boolean;
  disabled?: boolean;
};

export const DropOverlay = forwardRef<DropOverlayProps, 'div'>(
  ({ isDragActive, disabled, ...props }, ref) => {
    return (
      <Center
        ref={ref}
        display={isDragActive ? 'flex' : 'none'}
        w="100%"
        h="100%"
        position="fixed"
        top="0"
        left="0"
        opacity="0.8"
        zIndex="1"
        backgroundColor="gray.300"
        bgGradient="
        linear-gradient(
          to left top,
          transparent 0%,
          transparent 25%,
          white 25%,
          white 50%,
          transparent 50%,
          transparent 75%,
          white 75%
        )"
        bgSize="30px 30px"
        cursor={disabled ? 'not-allowed' : 'pointer'}
        _focus={{
          outline: 'none',
          boxShadow: 'transparent 0px 0px 0px 1px, focus 0px 0px 0px 3px',
        }}
        {...props}
      />
    );
  }
);
